export default __webpack_public_path__ + "assets/images/MBR-1e3883bec2389845b8cc434c7006958c.jpg";